export default (() => {
  $(function() {
    let cookie_widget = window.getCookie("cookie_widget");

    $('[data-widget]').each(function() {
      let $widgetEl = $(this);
      let widgetValue = $(this).attr('data-widget')
      if(!cookie_widget || cookie_widget != widgetValue) {
        $widgetEl.removeClass('closed');
        $('.floating-widget__close').on('click', function() {
          $widgetEl.addClass('closed')
          document.cookie = `cookie_widget=${widgetValue}; path=/;`;
        })
      }
    });
  });
})();
